import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { MANAGE_OPERATIONAL_AREAS_ROLES } from './core/consts/clockload-roles';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/home/home').then((m) => m.Home),
  },
  //#region MENU-AREAS OPERACIONAIS
  {
    path: 'areas/:areaKey',
    canActivate: [authGuard],
    loadComponent: () => import('./features/areas/area-page/area-page').then((m) => m.AreaPage),
  },
  //#endregion

  //#region MENU-ADMINISTRATIVO
  {
    path: 'operational-areas',
    canActivate: [authGuard],
    data: {
      roles: MANAGE_OPERATIONAL_AREAS_ROLES,
    },
    loadComponent: () =>
      import('./features/operational-areas/pages/operational-area-management/operational-area-management').then(
        (m) => m.OperationalAreaManagement,
      ),
  },
  {
    path: 'operational-areas/new',
    canActivate: [authGuard],
    data: {
      roles: MANAGE_OPERATIONAL_AREAS_ROLES,
    },
    loadComponent: () =>
      import('./features/operational-areas/pages/operational-area-form-page/operational-area-form-page').then(
        (m) => m.OperationalAreaFormPage,
      ),
  },
  {
    path: 'operational-areas/:areaKey/edit',
    canActivate: [authGuard],
    data: {
      roles: MANAGE_OPERATIONAL_AREAS_ROLES,
    },
    loadComponent: () =>
      import('./features/operational-areas/pages/operational-area-form-page/operational-area-form-page').then(
        (m) => m.OperationalAreaFormPage,
      ),
  },
  //#endregion

  //#region MENU-AJUDA
  {
    path: 'about',
    canActivate: [authGuard],
    loadComponent: () => import('./features/help/about/about').then((m) => m.About),
  },
  {
    path: 'tutorial',
    canActivate: [authGuard],
    loadComponent: () => import('./features/help/tutorial/tutorial').then((m) => m.Tutorial),
  },
  //#endregion

  //#region OUTROS
  {
    path: 'forbidden',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/errors/forbidden/forbidden').then((component) => component.Forbidden),
  },
  //#endregion

  { path: '**', redirectTo: '' },
];
